import React, { memo, useContext } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'

import { Checkbox, CustomDatePicker, SelectInput, Typography } from '../index'
import { util } from '../../../util'
import { useIconHandler } from '../../CustomHooks/useCustomHooks'
import { LanguageContext } from '../../../context/LanguageContext'
import { constants } from '../../../constants'

const SchedulePicker = ({
    startDate,
    startTime,
    endDate,
    endTime,
    isAllDay,
    toggleAllday,
    datePickerChangeHandler,
    startTimeError,
    endTimeError,
    startDateError,
    endDateError,
    isDisabled = false,
}) => {
    // Context
    const { strings } = useContext(LanguageContext)

    // Constants
    const { permissions } = constants
    const _renderEndProps = () => useIconHandler(util.AccessTimeIcon)
    const today = moment(moment().format('MM/DD/YYYY'))
    // TODO: console moment warning
    const minStartDate = moment(startDate).isBefore(today) ? startDate : today
    const timePickerOptions = util.listOfTime()

    // States
    const user_permissions = useSelector(({ auth }) => auth.user_permissions)
    const disabledByRole = !user_permissions.includes(
        permissions['APP-7NOWMANAGER-PROMOTION-WRITE']
    )

    // Handlers
    const timeChangeHandler = e => {
        const { value, name } = e.target
        datePickerChangeHandler(value, name)
    }

    return (
        <div className={'schedule__time mb-3'}>
            <p className={'paragraph bold'}>
                {strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_SCHEDULE_INTERVAL}
            </p>
            <div className={'pickers'}>
                <CustomDatePicker
                    minDate={minStartDate}
                    handleDateChange={datePickerChangeHandler}
                    selectedDate={startDate ? moment(startDate).format('MM/DD/YYYY') : ''}
                    name={'startDate'}
                    label={strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_SCHEDULE_START_DATE}
                    error={startDateError}
                    size={'sm'}
                    disabled={disabledByRole}
                />
                {!isAllDay && (
                    <SelectInput
                        margin={'ml-4 mb-4'}
                        size={'md'}
                        value={startTime}
                        onChange={datePickerChangeHandler}
                        onTextChange={timeChangeHandler}
                        error={startTimeError}
                        label={strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_SCHEDULE_START_TIME}
                        name={'startTime'}
                        options={timePickerOptions}
                        inputProps={{ end: _renderEndProps }}
                        disabled={isDisabled}
                    />
                )}
                <p className={'to'}>{strings.TO}</p>
                <CustomDatePicker
                    minDate={startDate}
                    handleDateChange={datePickerChangeHandler}
                    selectedDate={endDate ? moment(endDate).format('MM/DD/YYYY') : ''}
                    name={'endDate'}
                    label={strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_SCHEDULE_END_DATE}
                    size={'sm'}
                    error={endDateError}
                    disabled={disabledByRole}
                />
                {!isAllDay && (
                    <SelectInput
                        margin={'ml-4'}
                        size={'md'}
                        onChange={datePickerChangeHandler}
                        onTextChange={timeChangeHandler}
                        value={endTime}
                        error={endTimeError}
                        label={strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_SCHEDULE_END_TIME}
                        name={'endTime'}
                        options={timePickerOptions}
                        inputProps={{ end: _renderEndProps }}
                        disabled={isDisabled}
                    />
                )}
            </div>
            <p className={'schedule__rule-label paragraph italic text mt-5'}>
                {`${strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_SCHEDULE_TIME_MSG} `}
            </p>
            <div className={'schedule__allDay'}>
                <Checkbox
                    margin={'ml-0'}
                    checked={isAllDay}
                    onChange={toggleAllday}
                    isDisabled={isDisabled}
                />
                <Typography
                    text={strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_SCHEDULE_DAY}
                    className={'px-2'}
                />
            </div>
        </div>
    )
}

export default memo(
    SchedulePicker,
    (prevProps, nextProps) =>
        !(
            prevProps.startDate !== nextProps.startDate ||
            prevProps.endDate !== nextProps.endDate ||
            prevProps.startTime !== nextProps.startTime ||
            prevProps.endTime !== nextProps.endTime ||
            prevProps.startTimeError !== nextProps.startTimeError ||
            prevProps.endTimeError !== nextProps.endTimeError ||
            prevProps.isAllDay !== nextProps.isAllDay ||
            prevProps.startDateError !== nextProps.startDateError ||
            prevProps.endDateError !== nextProps.endDateError
        )
)
